import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import { getComment } from '../../../../../../../stores/comments/comments.selectors'

const mapStateToProps = (state, { id }) => {
  const comment = getComment(state, id)
  return {
    workId: comment.work.id
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onGoToWork: () => (window.location.href = `/works/${stateProps.workId}`)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ContextMenu)
